// utils
import PadCreatorPrescriptionProcedure from '../components-js/pad-prescription/PadPrescriptionProcedure';

const TEMPLATE_NAME = 'PAD_MODEL_CREATOR_PRESCRIPTION_PROCEDURE';

const initialState = {
  data: {
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padCreatorPrescription = new PadCreatorPrescriptionProcedure(state);

      return padCreatorPrescription.setLoading(true).setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const prescriptionProcedures = action.payload;

      const padCreatorPrescription = new PadCreatorPrescriptionProcedure(state);

      return padCreatorPrescription.prepare(prescriptionProcedures).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padCreatorPrescription = new PadCreatorPrescriptionProcedure(state);

      return padCreatorPrescription.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const prescriptionForm = action.payload;
      const padCreatorPrescription = new PadCreatorPrescriptionProcedure(state);

      // prettier-ignore
      return padCreatorPrescription
        .add(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadCreatorPrescriptionProcedure(state);

      return padCreatorPrescription.edit(code, prescriptionForm).getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
